import { OnInit, Component, NgModule, ViewChild, NgZone, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { BrowserModule, DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as $ from "jquery";
import { LoginHttp } from '../../../tsScripts/providers/http/LoginHttp';
import { PRODUCT_TS, DEFAULT_SUBDOMAIN_TS, URL_PRODUCT } from '../MainComponent';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { LoadingButtonModule } from '../../../tsScripts/directives/LoadingButton';
import { FloatingLabelModule } from '../../../tsScripts/directives/FloatingLabel';
import { TokenStorage } from '../../../tsScripts/providers/TokenStorage';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';
import { Util } from '../../../tsScripts/util/Util';
import { CookieService } from 'ngx-cookie-service';

declare let userInterface: any;
declare let DEFAULT_SUBDOMAIN: string;
//declare let WHITE_BRAND: string[];
declare let WHITE_BRAND_URL: string;

@Component({
    selector: 'login',
    templateUrl: "./login.html",
    providers: [LoginHttp],
    styleUrls: ["../../../styles/login.css"]
})
export class Login implements OnInit {
    hidePass = true;
    PRODUCT: any;
    loginLoading: boolean;
    subDomain: string;
    alertMessage: string;
    typeAlert: string;
    username: string;
    password: string;

    // 2FA visual
    step: 'credentials' | 'twofa' = 'credentials';
    codeDigits: string[] = ['', '', '', '', '', ''];
    pendingToken2FA: string = null;
    URL_PRODUCT_SAFE: SafeUrl;
    URL_PRODUCT: string;
    WHITE_BRAND: string[] = [];

    @ViewChild('elementIframe')
    elementIframe: ElementRef;

    userInterface: any = userInterface;

    constructor(private zone: NgZone,
        private LoginHttp: LoginHttp,
        private sanitizer: DomSanitizer,
        private router: Router,
        private route: ActivatedRoute,
        private tokenStorage: TokenStorage) {
        this.loginLoading = false;
        this.alertMessage = "";
        this.PRODUCT = PRODUCT_TS;
        this.subDomain = DEFAULT_SUBDOMAIN_TS;
        this.URL_PRODUCT = URL_PRODUCT + '?noRedirect=true';
        if (URL_PRODUCT != "") {
            this.URL_PRODUCT_SAFE = this.sanitizer.bypassSecurityTrustResourceUrl(this.URL_PRODUCT);

        }
    }

    validUser() {
        this.zone.run(() => {
            if (this.username != null && this.username != "" && this.password != null && this.password != "") {
                this.loginLoading = true;
                this.alertMessage = "";
                this.typeAlert = "";
                let param: any = {
                    product: this.PRODUCT.NAME_LUDY_PRODUCT,
                    username: this.username,
                    password: this.password
                }
                this.LoginHttp.validateUser(param).subscribe((response: any) => {
                    this.loginLoading = false;
                    this.password = "";

                    // Si la empresa tiene 2FA activo, el backend devuelve token2FA (sin token).
                    // Mostramos el paso OTP y esperamos la verificacion. Si no, login directo.
                    if (response && response.token2FA) {
                        this.pendingToken2FA = response.token2FA;
                        this.codeDigits = ['', '', '', '', '', ''];
                        this.alertMessage = "";
                        this.typeAlert = "";
                        this.step = 'twofa';
                    } else {
                        this.handleLoginSuccess(response);
                    }
                }, (error: ErrorDTO) => {
                    this.alertMessage = error.errorMessage;
                    this.typeAlert = "error"
                    this.loginLoading = false;
                    this.password = "";
                });
            } else {
                this.alertMessage = "Necesita completar todos los campos";
                this.typeAlert = "warning";
                this.loginLoading = false;
            }
        });
    }

    /**
     * Paso 2 de 2FA: envia el codigo OTP + token2FA al backend. Si es valido,
     * el backend devuelve el token normal y se ejecuta la redireccion original.
     */
    verifyCode() {
        this.zone.run(() => {
            let code = (this.codeDigits || []).join('');
            if (code.length < 6) {
                this.alertMessage = "Ingrese el codigo completo de 6 digitos";
                this.typeAlert = "warning";
                return;
            }
            if (!this.pendingToken2FA) {
                this.backToLogin();
                return;
            }
            this.loginLoading = true;
            this.alertMessage = "";
            this.typeAlert = "";
            let param: any = {
                authcode: code,
                token2fa: this.pendingToken2FA
            };
            this.LoginHttp.verify2FA(param).subscribe((response: any) => {
                this.loginLoading = false;
                this.handleLoginSuccess(response);
            }, (error: ErrorDTO) => {
                this.loginLoading = false;
                this.alertMessage = error.errorMessage || "Codigo incorrecto";
                this.typeAlert = "error";
                this.resetCodeInputs();
            });
        });
    }

    /**
     * Ejecuta la logica de sesion y redireccion con la respuesta que contiene el token.
     * Usado tanto para login sin 2FA como tras verificar el codigo OTP.
     */
    private handleLoginSuccess(response: any) {
        DEFAULT_SUBDOMAIN = response.domain;
        if (response.maintenance) {
            localStorage.setItem('maintenanceMsg', response.maintenance);
        } else {
            localStorage.removeItem('maintenanceMsg');
        }
        this.tokenStorage.setCookie(response.token);
        if (URL_PRODUCT != "") {
            /**
             * Se concatena el subdominio si la empresa tiene marca blanca
             */
            if (this.WHITE_BRAND.indexOf(DEFAULT_SUBDOMAIN) >= 0 && !this.URL_PRODUCT.includes(DEFAULT_SUBDOMAIN) && !URL_PRODUCT.includes('localhost')) {
                this.URL_PRODUCT = WHITE_BRAND_URL + '/' + DEFAULT_SUBDOMAIN;
                this.tokenStorage.setItemLocalStorage('default_subdomain', DEFAULT_SUBDOMAIN);
            } else {
                this.tokenStorage.removeItemLocalStorage('default_subdomain');
            }
            if (response.maintenance && response.maintenance !== '') {
                if (URL_PRODUCT.includes('localhost') || URL_PRODUCT.includes('192.168.')) {
                    return window.location.href = this.URL_PRODUCT + '&token=' + response.token + '&subdomain=' + DEFAULT_SUBDOMAIN + '&maintenance=' + response.maintenance;
                } else {
                    return window.location.href = this.URL_PRODUCT + '&maintenance=' + response.maintenance;
                }
            } else {
                if (URL_PRODUCT.includes('localhost') || URL_PRODUCT.includes('192.168.')) {
                    return window.location.href = this.URL_PRODUCT + '&token=' + response.token;
                } else {
                    return window.location.href = this.URL_PRODUCT + '&token=' + response.token;
                }
            }
        } else {
            this.tokenStorage.setToken(response.token);
            this.router.navigateByUrl('/home');
        }
    }

    /** Limpia las casillas OTP (modelo + DOM) y devuelve el foco a la primera. */
    private resetCodeInputs() {
        this.codeDigits = ['', '', '', '', '', ''];
        for (let i = 0; i < 6; i++) {
            let box: any = document.getElementById('otp-' + i);
            if (box) { box.value = ''; }
        }
        let first: any = document.getElementById('otp-0');
        if (first) { first.focus(); }
    }

    /** trackBy por indice: evita que ngForm reordene/recree las casillas y pierda foco. */
    trackByIndex(index: number): number {
        return index;
    }

    /** Maneja el input de cada casilla OTP: filtra a un digito y avanza foco. */
    onCodeInput(index: number, event: any) {
        let input: any = event.target;
        let digit = (input.value || '').replace(/[^0-9]/g, '').slice(-1);
        input.value = digit;
        this.codeDigits[index] = digit;
        if (digit && index < 5) {
            let next: any = document.getElementById('otp-' + (index + 1));
            if (next) { next.focus(); }
        }
    }

    /**
     * Backspace fluido: si la casilla tiene digito, lo borra y se queda;
     * si ya esta vacia, borra la anterior y mueve el foco hacia atras.
     */
    onCodeKeydown(index: number, event: any) {
        if (event.key !== 'Backspace') { return; }
        let input: any = event.target;
        if (input.value) {
            input.value = '';
            this.codeDigits[index] = '';
            event.preventDefault();
        } else if (index > 0) {
            let prev: any = document.getElementById('otp-' + (index - 1));
            if (prev) {
                prev.value = '';
                this.codeDigits[index - 1] = '';
                prev.focus();
            }
            event.preventDefault();
        }
    }

    /** Soporta pegar el codigo completo; llena casillas y refleja en el DOM. */
    onCodePaste(event: any) {
        let text = (event.clipboardData || (window as any).clipboardData).getData('text') || '';
        let digits = text.replace(/[^0-9]/g, '').slice(0, 6).split('');
        for (let i = 0; i < 6; i++) {
            this.codeDigits[i] = digits[i] || '';
            let box: any = document.getElementById('otp-' + i);
            if (box) { box.value = this.codeDigits[i]; }
        }
        let lastFilled = Math.min(digits.length, 6) - 1;
        let target: any = document.getElementById('otp-' + (lastFilled < 0 ? 0 : lastFilled));
        if (target) { target.focus(); }
        event.preventDefault();
    }

    /** Vuelve al paso de credenciales. */
    backToLogin() {
        this.step = 'credentials';
        this.pendingToken2FA = null;
        this.codeDigits = ['', '', '', '', '', ''];
        this.alertMessage = "";
        this.typeAlert = "";
        this.loginLoading = false;
    }

    private getMessage(msgType: string) {
        let msg = Util.getParameterByName('msg');
        if (msg != '') {
            this.alertMessage = msg;
            (msgType != "") ? this.typeAlert = msgType : this.typeAlert = "info";
        }
    }

    private validate() {
        if ((this.tokenStorage.getToken() !== undefined) && (this.tokenStorage.getToken() !== null)) {
            this.LoginHttp.validateToken().subscribe((response) => {
                this.router.navigateByUrl('/home');
            }, (error) => {

            });
        } else {
            // window.location.href= 'index.html'; 
        }
    }

    ngOnInit() {
        this.tokenStorage.verifyCookieAndLocalStorage();
        // this.validate();
        this.getMessage(Util.getParameterByName('msgType'));
        $("body").removeClass().addClass("login-background");
        let bg_login_class = {
            "background": `url(${this.PRODUCT.BACKGROUND_LOGIN}) no-repeat fixed center center`,
            "background-size": "cover",
            "background-attachment": "fixed"
        };
        $('.login-background').css(bg_login_class);
    }
}

@NgModule({
    declarations: [Login],
    imports: [FormsModule, BrowserModule, LoadingButtonModule, RouterModule, FloatingLabelModule],
    providers: [TokenStorage, CookieService],
    entryComponents: [],
    exports: []
})
export class LoginModule {
}